import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  ButtonComponent,
  ContentComponent,
  SingleCardLayoutComponent,
} from '@lyceo/shared/ui';
import { AuthFacade } from '@lyceo/shared/auth/data-access';

@Component({
  selector: 'lyceo-auth-error',
  imports: [SingleCardLayoutComponent, ContentComponent, ButtonComponent],
  templateUrl: './auth-error.component.html',
  styleUrls: ['./auth-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthErrorComponent {
  private readonly authFacade: AuthFacade = inject(AuthFacade);

  public reload(): void {
    this.authFacade.retryLoadDiscoveryDocument();
  }
}
